
import { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import TextField from "@mui/material/TextField";
import FormControl from "@mui/material/FormControl";
import CloseIcon from '@mui/icons-material/Close';
import DoneIcon from '@mui/icons-material/Done';
import { v4 as uuidv4 } from 'uuid';
import { Grid, Typography } from '@mui/material';
import { useDispatch, useSelector } from "react-redux";
import "../../../Assets/Styles/Containers/_dashboard.scss";
import '../../../Assets/Styles/Containers/_inspection.scss';
import { updateInspectionDataCall } from '../../Redux/Actions/CommonActions';
import { GetUTCTime } from '../../Helpers/GetUTCTime';
import { updateISNTemplates } from '../../Helpers/ApiCall';
import Preloader from '../../Helpers/Preloader';
import PictureAsPdfOutlinedIcon from "@mui/icons-material/PictureAsPdfOutlined";
import { TEMPLATE_PICKER_PAPER_PROPS, TemplateSearchEmptyState, TemplateSearchField } from "../../Common/TemplateSearch/TemplateSearchField";
import { filterTemplatesByName } from "../../Helpers/TemplateSearchUtils";

const ISNTemplateModal = ({ showISNTemplateModal, setShowISNTemplateModal, setZeroState }) => {
  const [masterTemplateData, setMasterTemplateData] = useState([]);
  const [selectedTemplates, setSelectedTemplates] = useState([])
  const [selectedTemplatesGuid, setSelectedTemplatesGuid] = useState([]);
  const [templateSearchQuery, setTemplateSearchQuery] = useState("");
  // redux
  const dispatch = useDispatch();
  const storeData = useSelector((state) => state.CommonReducer);
  const searchFilteredTemplates = filterTemplatesByName(masterTemplateData, templateSearchQuery);
  const handleClose = () => {
    setShowISNTemplateModal(false)
    setTemplateSearchQuery("")
  }
  const handleISNTemplateSelection = (template) => {
    const isSelected = selectedTemplatesGuid?.includes(template.guid)
    if (isSelected) {
      setSelectedTemplates(prev => prev.filter(elem => elem.guid !== template.guid))
      setSelectedTemplatesGuid(prev => prev.filter(elem => elem !== template.guid))
    }
    else {
      setSelectedTemplates(prev => [...prev, template])
      setSelectedTemplatesGuid(prev => [...prev, template.guid])
    }
  }

  const handleISNTemplateSave = async (selectedTemplates) => {
    let errorEl = document.getElementById('template_selection_error_text');

    if (selectedTemplatesGuid.length === 0) {
      errorEl.innerText = "Choose a template to start";
      return;
    }

    errorEl.innerText = "";

    let processedTemplates = [];

    for (let template of selectedTemplates) {

      // Not in default => set master_template_guid = template_guid
      processedTemplates.push({
        template_guid: template,
        master_template_guid: template
      });

    }
    const formData = {
      guid: sessionStorage.getItem("guid"),
      order_id: sessionStorage.getItem("guid"),
      inspection_from: "ISN",
      templates: processedTemplates,  // Pass processed templates here
    };

    updateISNTemplates(dispatch, formData);
    setZeroState(false);
    setShowISNTemplateModal(false);
  };


  useEffect(() => {
    if (storeData?.IsnMasterTemplates && storeData?.IsnMasterTemplates.length !== 0) {
      setMasterTemplateData(storeData?.IsnMasterTemplates);
    }
  }, [storeData?.IsnMasterTemplates])

  return (
    <>
      <Dialog className='dialog-container-new-category'
        open={showISNTemplateModal}
        onClose={handleClose}
        aria-labelledby="category-modal"
        onBackdropClick="false"
        aria-describedby="category-modal-description"
        PaperProps={TEMPLATE_PICKER_PAPER_PROPS}
      >
        <div className="close-wrapper-new-line">
          <CloseIcon onClick={handleClose} />
        </div>
        <DialogTitle className='new-category-dialog-title mb-6'>{"Add templates"}</DialogTitle>
        <span className='category-dialog-subtitle p-custom'>Choose templates below to add.</span>
        <DialogContent className="dialog-content-new-category template-picker-content">
          <TemplateSearchField searchQuery={templateSearchQuery} onSearchQueryChange={setTemplateSearchQuery} />
          <Grid container className="input-controll template-picker-list">
            <Grid item xs={12} >
              {/* Only once the master list has loaded, so it doesn't flash while fetching */}
              {masterTemplateData?.length > 0 && searchFilteredTemplates?.length === 0 && <TemplateSearchEmptyState />}
              {
                searchFilteredTemplates?.map((template) => (
                  <Typography
                    onClick={() => handleISNTemplateSelection(template)}
                    key={template?.guid} className={`bordered__text ${selectedTemplatesGuid?.includes(template?.guid) ? 'cat_selected' : ''}`}
                  >  <span className='bordered__text__content' style={{ display: "flex", alignItems: "center" }}>  <span style={{ marginRight: "12px" }}  >
                    {template?.is_pdf_template === 1 ? (
                      <PictureAsPdfOutlinedIcon />
                    ) : null}
                  </span>{template?.name}</span>
                    <DoneIcon className='cat_seleted_icon' />
                  </Typography>
                ))
              }
            </Grid>

          </Grid>
        </DialogContent>

        <DialogActions className='template-selection-modal-action'>
          <div id="template_selection_error_text"></div>
          <Button className="add-category-btn"
            onClick={() => handleISNTemplateSave(selectedTemplatesGuid)}
          >
            Add to report
          </Button>
        </DialogActions>
      </Dialog>
    </>
  )
}

export default ISNTemplateModal